module.exports = __webpack_public_path__ + "img/03_noff_open_L1.2c70e04d.svg";